/* @ngInject */
function DocumentItemController ($scope, $state, $timeout, $location, $q, UdsModalService, SegmentService) {
  const getConfirmDeleteTaskDocumentDialogController = () => $q.when(import('../../../workflow/dialogs/confirm-delete-task-document/confirm-delete-task-document-dialog.controller'))
  const api = {
    getConfirmDeleteTaskDocumentDialogController,
    _deleteDocument,
    _editDocument,
    _openDocument
  }
  this.getApi = () => api

  activate()

  function activate () {
    $scope.goBackRoute = $location.path().replace(/^\//, '')
  }

  $scope.deleteDocument = (event) => {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation()
    }
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault()
    }
    api._deleteDocument()
  }

  $scope.editDocument = (event) => {
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation()
    }
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault()
    }
    api._editDocument()
  }

  $scope.openDocument = () => {
    api._openDocument()
  }

  function _deleteDocument () {
    api.getConfirmDeleteTaskDocumentDialogController().then(({ ConfirmDeleteTaskDocumentDialogController }) => {
      const confirmDeleteTaskDocumentDialog = UdsModalService.createModal({
        controller: ConfirmDeleteTaskDocumentDialogController,
        modalName: 'confirmDeleteTaskDocumentDialog',
        data: {
          documentId: $scope.document.id,
          taskId: $scope.taskId
        }
      })

      confirmDeleteTaskDocumentDialog.open()
    })
  }

  function _editDocument () {
    SegmentService.track('doc-edit', { doc_id: $scope.document.id, page: 'workflow' })
    _tryCloseDialog()
    // Necessário para garantir que o modal seja fechado antes de redirecionar para o editor
    $timeout(() => {
      $state.go('documents.editor', { id: $scope.document.id, goBackRoute: $scope.goBackRoute })
    }, 0)
  }

  function _openDocument () {
    _tryCloseDialog()
    // Necessário para garantir que o modal seja fechado antes de redirecionar para o editor
    $timeout(() => {
      $state.go('documents.editor', { id: $scope.document.id, goBackRoute: $scope.goBackRoute, readOnly: 'true' })
    }, 0)
  }

  function _tryCloseDialog () {
    let currentScope = $scope
    while (currentScope) {
      if (typeof currentScope.closeDialog === 'function') {
        currentScope.closeDialog()
        return true
      }
      currentScope = currentScope.$parent
    }
    return false
  }
}

export { DocumentItemController }
